import { blue, orange, grey, purple } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: ["Inter", "Galano Grotesque Alt"].join(","),
    fontSize: 15,
    H4: {
      fontSize: "32px !important",
      fontWeight: 600,
      fontFamily: "Galano Grotesque Alt",
    },
    tinyRegular: {
      fontSize: "12px !important",
      fontWeight: 400,
      fontFamily: "Galano Grotesque Alt",
    },
    tinyMedium: {
      fontSize: "12px !important",
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
    },
    small: {
      fontSize: "14px !important",
      lineHeight: "20px",
      fontFamily: "Galano Grotesque Alt",
    },
    smallMedium: {
      fontSize: "14px !important",
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
    },
    smallSemiBold: {
      fontSize: "14px !important",
      fontWeight: 600,
      fontFamily: "Galano Grotesque Alt",
    },
    smallBold: {
      fontSize: "14px !important",
      fontWeight: 700,
      fontFamily: "Galano Grotesque Alt",
    },
    regular: {
      fontSize: "16px",
      fontFamily: "Galano Grotesque Alt",
    },
    regularMedium: {
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
    },
    regularSemiBold: {
      fontSize: "16px !important",
      fontWeight: 600,
      fontFamily: "Galano Grotesque Alt",
    },
    mediumMedium: {
      fontSize: "18px !important",
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
    },
    mediumSemiBold: {
      fontSize: "18px !important",
      fontWeight: 600,
      fontFamily: "Galano Grotesque Alt",
    },
    largerMedium: {
      fontSize: "24px !important",
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
    },
    largeSemiBold: {
      fontSize: "20px !important",
      fontWeight: 600,
      fontFamily: "Galano Grotesque Alt",
    },
    largeBold: {
      fontSize: "20px !important",
      fontWeight: 700,
      fontFamily: "Galano Grotesque Alt",
    },
  },
  palette: {
    primary: {
      main: "#FFAA01",
      menuActive: "#0B416F",
      neautrals: "#262626",
      success: {
        500: "#12B76A",
        600: "#4caf50",
        700: "#027A48",
      },
      error: {
        500: "#F04438",
        700: "#B42318",
      },
    },
    secondary: {
      main: "#005EA9",
    },
    text: {
      main: "#000",
    },
    paper: {
      main: "#fff",
    },
    neutral: {
      main: "#666666",
      light: "#AAAAAA",
      dark: "#444444",
      dark2: "#181D27",
      dark3: "#4A5565",
    },
    alternate: {
      main: "#054D87",
      6: "#666666",
      8: "#A4A7AE",
    },
    background: {
      default: "#EEEEEE",
      avatar: "#bdbdbd",
      subtle: "#F9FAFB",
      light: "#F1F5F9",
      alternate: {
        1: "#F0F8FF",
        2: "#07294A",
        3: "#F3F4F6",
      },
    },
    button: {
      link: "#BB5902",
      star: "#F2B347",
      search: "#F49400",
      normal: "#015EA9",
    },
    border: {
      main: "#D9D9D9",
      lighter: "#CCC",
      lightest: "#EEE",
      divider: "#E9EAEB",
    },
    brand: {
      orange: {
        ...orange,
        1: "#7C380B",
        50: "#FFFDEA",
      },
      blue: {
        ...blue,
        100: "#E0EFFE",
        400: "#36ACFA",
        700: "#175CD3",
      },
      grey: {
        ...grey,
        300: "#D0D5DD",
        700: "#414651",
      },
      purple,
    },
  },
  primaryColor: "#FFAA01",
  secondaryColor: "#005EA9",
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // '& .MuiOutlinedInput-root': {
          // 	fontSize: 16,
          // 	borderRadius: '8px',
          // },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          fontSize: "16px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          borderRadius: "8px",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 36,
          height: 20,
          padding: 0,
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
              transform: "translateX(16px)",
              color: "#fff",
              "& + .MuiSwitch-track": {
                backgroundColor: "#005EA9",
                opacity: 1,
                border: 0,
              },
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 16,
            height: 16,
          },
          "& .MuiSwitch-track": {
            borderRadius: 24 / 2,
            backgroundColor: "#E9E9EA",
            opacity: 1,
            transition: "background-color 300ms",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltipPlacementLeft: {
          marginRight: "5px !important",
        },
        tooltipPlacementRight: {
          marginLeft: `5px !important`,
        },
        tooltipPlacementTop: {
          marginBottom: `5px !important`,
        },
        tooltipPlacementBottom: {
          marginTop: `5px !important`,
        },
      },
    },
  },
});
